import http from '../services/http';
import { typeAs } from '../services/utils';

export default {
  namespaced: true,

  state: {
    homepage: null,
  },

  mutations: {
    INIT_HOMEPAGE(state) {
      state.homepage = {};
    },
    CLEAR_HOMEPAGE(state) {
      state.homepage = null;
    },
    SET_HOMEPAGE(state, data) {
      state.homepage = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_HOMEPAGE');
    },

    find({ commit }) {
      return http('/homepage')
        .then((response) => response.body)
        .then(typeAs('HomePage'))
        .then((response) => {
          commit('SET_HOMEPAGE', response);
          return response;
        });
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/homepage/${id}`, { method: 'PUT', data })
        : http('/homepage', { method: 'POST', data });

      return request.then((response) => response.body.item);
    },

    getBuOptions() {
      return http('/homepage/bu_select_options')
        .then((response) => response.body);
    },
  },
};
